import React from "react";
import { Link } from "react-router-dom";
import { Sparkles, Instagram, Twitter, Github } from "lucide-react";

export default function Footer() {
  return (
    <footer className="mt-24 border-t-2 border-ink bg-brand-sky" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-14 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-3">
            <span className="grid place-items-center w-9 h-9 bg-brand-yellow neo-sm rounded-lg"><Sparkles className="w-5 h-5" /></span>
            <span className="font-display font-bold text-2xl">FabricATE</span>
          </div>
          <p className="max-w-sm font-body font-semibold text-ink/80">
            Wearable art for loud humans. Shop bold tees or fabricate your own in our Design Studio.
          </p>
          <div className="flex gap-3 mt-5">
            {[Instagram, Twitter, Github].map((Icon, i) => (
              <span key={i} className="grid place-items-center w-10 h-10 bg-white neo-sm rounded-lg neo-press cursor-pointer">
                <Icon className="w-5 h-5" />
              </span>
            ))}
          </div>
        </div>
        <div>
          <h4 className="font-display font-bold mb-3">Explore</h4>
          <ul className="space-y-2 font-semibold">
            <li><Link to="/shop" className="hover:underline">Shop All</Link></li>
            <li><Link to="/designer" className="hover:underline">Design Studio</Link></li>
            <li><Link to="/account" className="hover:underline">My Orders</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-display font-bold mb-3">Help</h4>
          <ul className="space-y-2 font-semibold">
            <li>Shipping &amp; Returns</li>
            <li>Size Guide</li>
            <li>Contact Us</li>
          </ul>
        </div>
      </div>
      <div className="border-t-2 border-ink py-4 text-center font-bold text-sm">
        © {new Date().getFullYear()} FabricATE — Made with color.
      </div>
    </footer>
  );
}
